import CodeBlock from "@tiptap/extension-code-block"
import type { Node } from "@tiptap/pm/model"

export const SNIPPET_NODE = "snippet"

export const SNIPPET_DATA_TYPES = {
  iframe: "snippet-iframe",
} as const

function escapeHtmlForSrcdoc(html: string): string {
  return html
    .replace(/&/g, "&amp;") // Only escape quotes to prevent breaking the attribute
    .replace(/"/g, "&quot;") // Only escape quotes to prevent breaking the attribute
    .replace(/'/g, "&apos;") // Escape single quotes (using &#39; instead of &apos; for better compatibility)
}

export interface SnippetTranslations {
  placeholder: string
  placeholderUpdate: string
  buttonCreate: string
  buttonUpdate: string
  buttonCreating: string
  buttonUpdating: string
  delete: string
}

interface SnippetOptions {
  backendUrl: string
  getJWT: () => string | null
  translations: SnippetTranslations
}

export const Snippet = CodeBlock.extend<SnippetOptions>({
  addOptions() {
    return {
      backendUrl: "",
      getJWT: () => null,
      translations: {
        placeholder: "",
        placeholderUpdate: "",
        buttonCreate: "",
        buttonUpdate: "",
        buttonCreating: "",
        buttonUpdating: "",
        delete: "",
      },
    }
  },
  name: SNIPPET_NODE,
  content: "text*",

  parseHTML() {
    return [{ tag: `div[data-type="${SNIPPET_NODE}"]` }]
  },

  renderHTML({
    node,
    HTMLAttributes,
  }: {
    node: Node
    HTMLAttributes: Record<string, unknown>
  }) {
    const code = node.textContent || ""
    const htmlContent = iframeTemplate(code)
    const escapedHtmlContent = escapeHtmlForSrcdoc(htmlContent)

    // Create the iframe HTML string directly to avoid JSON.stringify escaping newlines in srcdoc
    const iframeHtml = `
    <iframe
      data-type="${SNIPPET_DATA_TYPES.iframe}"
      srcdoc="${escapedHtmlContent}"
      sandbox="allow-scripts"
      credentialless
      referrerpolicy="no-referrer"
    >
    </iframe>`

    return ["div", { "data-type": SNIPPET_NODE, ...HTMLAttributes }, iframeHtml]
  },
})

export function iframeTemplate(code: string) {
  return `<!DOCTYPE html>
<html>
  <head>
    <meta charset="utf-8" />
    <style>
    *, *::before, *::after { box-sizing: border-box; }
    body, h1, h2, h3, h4, p,
    figure, blockquote, dl, dd {
      margin: 0;
    }
    </style>
  </head>
  <body>${code}</body>
  <script>
    let lastHeight = 0;

    function updateHeight() {
      const height = document.body.scrollHeight;
      if (height !== lastHeight) {
        lastHeight = height;
        window.parent.postMessage({ type: 'snippet-resize', height }, '*');
      }
    }

    const ro = new ResizeObserver(updateHeight);
    ro.observe(document.body);
    setInterval(updateHeight, 200);

    updateHeight();
  </script>
</html>`
}
